import { AlertType } from '@gym-atoms/Alert/Alert';
import AccessCategoryMappingForm from '@gym-organisms/AccessCategoryMapping/AccessCategoryMappingForm';
import AccessCategoryMappingList from '@gym-organisms/AccessCategoryMapping/AccessCategoryMappingList';
import { AccessCategoryMapping } from '@gym-particles/types/AccessCategoryMapping';
import { useAppSelector } from '@gym-redux/store';
import { Card } from 'primereact/card';
import { RefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { GymChainAccessCategoryTable } from '../../../particles/types/GymChainAccessCategory';

const GymAccessCategoryMappingPage = (props: GymAccessCategoryMappingProps) => {
  const { t } = useTranslation();
  const { chainId, gymId } = useParams<{ chainId: string; gymId: string }>();
  const [accessCategoryMapping, setAccessCategoryMapping] = useState<GymChainAccessCategoryTable>();
  const userRole = useAppSelector((state) => state.user.userRole);

  return (
    <>
      <Card className="p-card-w-table">
        <AccessCategoryMappingList
          gymId={+gymId}
          chainId={+chainId}
          heading={t('ACCESS_CATEGORY.HEADER_TEXT')}
        />
      </Card>
    </>
  );
};

export interface GymAccessCategoryMappingProps {
  alertRef: RefObject<AlertType>;
}

export default GymAccessCategoryMappingPage;
